/**
 * 新版首页 
 * created by liyaoh 2021-04-09
 */
import React, { Component } from "react";
import _ from "lodash";
import classNames from "classnames";
import Ajax from "Pub/js/ajax";
import "./index.less";
import withDragDropContext from "Pub/js/withDragDropContext";
//自定义组件
import MySider from "./LeftSider";
import MyContent from "./content";
import MyFooter from "./footer";
import HelpToolTip from "./LeftSider/HelpToolTip";
import { GetQuery, getWindow } from "Pub/js/utils";
import { connect } from "react-redux";
import * as utilService from "./utilService";
import {
    updateGroupList,
    clearData,
    initGroups,
    setJson,
    toggleEditStatus,
    setAppGroupData,
    setSiderCollapsed,
    setLeftHelpTipVisible,
    setDefaultAppGroupData,
    updateEditSiderStatus,
    setWorkbenchConfig
} from "Store/GridLayout/action";
import { setWorkbenchId, setLinkageData } from "Store/appStore/action";
import Notice from "Components/Notice";
import CustomDragLayer from "./customDragLayer";
import { getMulti } from "Pub/js/getMulti";
import platform from "Pub/js/platform";
const { PubSub, createPageIcon } = platform;
const { NCDiv, NCTooltip } = platform.base;
class HomePage extends Component {
    constructor(props) {
        super(props);
        //获得url中的参数
        this.urlRequestObj = GetQuery(this.props.location.search);
        const relateidObj = utilService.getRelateidObj(
            this.urlRequestObj.pk_responsibility,
            this.urlRequestObj.is_group,
            this.urlRequestObj.workbenchid
        );
        this.siderRef = React.createRef();
        this.contentRef = React.createRef();
        this.state = {
            relateidObj: relateidObj,
            // [NCC-45253]大佬们要求把这个新作的功能去掉
            origQueryWorkbenchData: [],
            disableDeduplicate: true,
            duplicateInEditing: false,
        };
    }
    //清除redux
    componentWillUnmount() {
        this.props.clearData();
        PubSub.unsubscribe(this.reloadDesignDesktopPub); // 移除订阅
    }

    componentDidMount() {
        let callback = (json) => {
            this.props.setJson(json);
            //请求完多语再切换
            //通过路由跳转至编辑态
            if (this.urlRequestObj.editable) {
                this.props.toggleEditStatus(true);
            }
            //职责或集团管理员应用设置进来请求数据
            if (this.urlRequestObj.pk_responsibility || this.urlRequestObj.is_group || this.urlRequestObj.workbenchid) {
                this.getGroupListData();
                //异步目的在首页修改title之后修改
                setTimeout(() => {
                    getWindow().document.title = this.props.json["DesktopSetting-000077"]; // 浏览器标题修改为工作台设计器
                });
            }
            if (this.urlRequestObj.workbenchid) {
                // 工作台设计、预览不重置name，会导致一直打开新页签
            } else {
                // 重置首页的name，在其他页面通过各种方式跳转到首页name不会改变，导致打开之前打开过的节点不会新页签打开(yonbip域名会有问题)
                getWindow().name = '';
            }
        };
        getMulti({
            moduleId: "DesktopSetting",
            // currentLocale: 'zh-CN',
            domainName: "workbench",
            callback,
        });
        document.body.classList.add('workbench-home');

        this.reloadDesignDesktopPub = PubSub.subscribe("reloadDesignDesktopData", () => {
            this.getGroupListData(true);
        });
    }

    // 生成空分组信息
    getEmptyGroupInfo = () => {
        return {
            pk_app_group: "newGroupItem" + new Date().getTime(),
            groupname: `${this.props.json["DesktopSetting-000002"]}` /* 国际化处理： 分组*/,
            type: "group",
            apps: [],
        }
    }

    getGroupListData = (reload = false) => {
        let { relateidObj } = this.state;
        let ajaxData = {
            isuser: relateidObj.code, //0职责 1用户 2集团
        };
        if (relateidObj.type === "workbench") {
            ajaxData.workbenchid = relateidObj.data;
        } else if (relateidObj.code === "0") {
            ajaxData.relateid = relateidObj.data;
        }
        let queryUrl = this.props.location && this.props.location.search;
        if (queryUrl && queryUrl.indexOf("pk_responsibility") !== -1) {
            relateidObj.code = "0"; //职责
            this.setState({
                relateidObj: {
                    ...relateidObj,
                    code: "0",
                },
            });
            ajaxData.isuser = "0";
            // let querySubString = queryUrl.substring(
            //     queryUrl.indexOf("pk_responsibility")
            // );
            // let relateid = querySubString.substring(
            //     querySubString.indexOf("=") + 1
            // );
            ajaxData.relateid = relateidObj.data; //存relateid
        } else if (queryUrl && queryUrl.indexOf("is_group=true") !== -1) {
            // 集团管理员应用管理跳转工作桌面设置 2019-08-16
            ajaxData.isuser = "2";
        }
        Ajax({
            url: `/nccloud/platform/appregister/queryworkbench.do`,
            info: {
                name: this.props.json["DesktopSetting-000004"] /* 国际化处理： 工作桌面配置*/,
                action: this.props.json["DesktopSetting-000024"] /* 国际化处理： 工作桌面查询*/,
            },
            data: ajaxData,
            loading: true,
            success: (res) => {
                if (res) {
                    let { data, success } = res.data;
                    // [NCC-45253]大佬们要求把这个新作的功能去掉
                    this.setState({
                        origQueryWorkbenchData: data,
                    });
                    if (success && data && data.length > 0) {
                        if (!data[0].groups.length) { // 没有分组，默认加一个
                            data[0].groups.push(this.getEmptyGroupInfo());
                        }
                        this.setState({
                            disableDeduplicate: !data[0].isdisplay,
                        });
                        this.props.setWorkbenchId(data[0].pk_workbench);
                        this.props.setLinkageData(utilService.getEffectiveLinkData(data[0].workbenchLinkConfigShowVOS, data[0].groups));
                        let appGroupMap = utilService.initDesktopApp(data[0].groups) // 聚合应用数据
                        this.props.setDefaultAppGroupData(_.cloneDeep(appGroupMap)); //设置默认聚合应用
                        this.props.setAppGroupData(appGroupMap); //设置聚合应用
                        this.props.updateGroupList(data[0].groups);
                        this.props.initGroups(data[0].groups);
                        reload && this.props.updateEditSiderStatus(false); // 重载数据销毁侧拉编辑状态
                        //桌面编辑态加载完发个事件
                        setTimeout(() => { // 延迟一下，常用应用内部的常用链接挂载时机稍晚一些
                            PubSub.publish("onChangeDesktopEditable", true);
                        })
                        this.props.setWorkbenchConfig(data[0].workbench_configuration);
                    } else {
                        if (success && data && data.length === 0) {
                            // Notice({ status: 'warning', msg: this.props.json['DesktopSetting-000025'] });/* 国际化处理： 工作桌面为空，请配置*/
                        } else {
                            Notice({ status: "error", msg: data });
                        }
                    }
                }
            },
        });
    };
    //将sider中的appGroupArr传给父组件
    handleUpdateAppGroups = (callback) => {
        callback();
    };
    onCheckDeduplication = (groups) => {
        let apps = _.flattenDeep(
            _.map(groups, (el) => el.apps),
            (el) => el.cardid
        );
        let deduplicateApps = _.uniqBy(apps, (el) => el.cardid);
        this.setState({
            disableDeduplicate: deduplicateApps.length === apps.length,
            duplicateInEditing: deduplicateApps.length !== apps.length,
        });
    };
    //桌面浏览态进入编辑态
    onEnterEditable = (isEmpty = false) => {
        //空桌面进编辑态显示左栏，非空桌面隐藏左栏
        this.props.setSiderCollapsed(!isEmpty);
    };

    // 工作台管理节点设计桌面显示注意事项
    renderHelpTip = () => {
        const { editable, json } = this.props;
        const content = (
            <div className="helptip-contnet">
                {/* 国际化处理： 设置工作桌面注意事项：*/}
                <div className="helptip-title">{json["DesktopSetting-000065"]}</div>
                <p>{json["DesktopSetting-000066"]}</p>
                <p>{json["DesktopSetting-000067"]}</p>
                <p>{json["DesktopSetting-000068"]}</p>
                <p>{json["DesktopSetting-000069"]}</p>
                <p>{json["DesktopSetting-000070"]}</p>
                <p>{json["DesktopSetting-000071"]}</p>
                <p>{json["DesktopSetting-000072"]}</p>
                <p>{json["DesktopSetting-000073"]}</p>
                <p>{json["DesktopSetting-000074"]}</p>
                <p>{json["DesktopSetting-000075"]}</p>
                <p>{json["DesktopSetting-000076"]}</p>
            </div>
        )
        if (editable && this.urlRequestObj.workbenchid) {
            return (
                <NCTooltip className="duty-help-tooltip" placement="left" overlay={content}>
                    <div className="helptip-container">
                        <i className="iconfont icon-bangzhutishi" />
                    </div>
                </NCTooltip>
            )
        }
    }

    handleClearAll = (e) => {
        this.contentRef.current.handleClearAll(e);
    }
    addFirstGroupItem =() => {
        this.contentRef.current.addFirstGroupItem();
    }

    render() {
        const { relateidObj } = this.state;
        const { workbenchData, editable } = this.props;
        const isDesign = relateidObj.type === 'workbench'; // 桌面设计
        const btnsArea = <MyFooter
            relateidObj={relateidObj}
            origQueryWorkbenchData={this.state.origQueryWorkbenchData}
            disableDeduplicate={this.state.disableDeduplicate}
            duplicateInEditing={this.state.duplicateInEditing}
            onCheckDeduplication={this.onCheckDeduplication}
            onClearAll={this.handleClearAll}
            addFirstGroupItem={this.addFirstGroupItem}
        />
        return [
            <NCDiv areaCode={NCDiv.config.HEADER}>
                <NCDiv
                    fieldid={this.props.json["DesktopSetting-000043"] /* 国际化处理： 桌面设置*/}
                    areaCode={NCDiv.config.Title}
                />
            </NCDiv>,

            // 设计器操作按钮区
            editable && isDesign
            ?
            // 借用一下标准单据的样式
            <div className="nc-bill-tree-table">
                <div className="header">
                    {/* 页面大图标 */}
                    {createPageIcon()}
                    {/* 标题 title*/}
                    <div className="title">{this.props.json['DesktopSetting-000093' /* 工作台设计器 */]}：{ workbenchData && workbenchData.length && workbenchData[0].name }</div>
                    {/* 按钮组 btn-group */}
                    <div className="btn-group">
                        { btnsArea }
                    </div>
                </div>
            </div> : null,

            <div ref={ref => this.desktopSettingRef = ref} className={classNames("nc-desktop-setting", { 'editing': editable }, { 'workbench-design': editable && isDesign })}>
                {this.props.editable && (
                    <MySider
                        ref={this.siderRef}
                        relateidObj={this.state.relateidObj}
                        {...this.props}
                    />
                )}
                <MyContent
                    ref={this.contentRef}
                    relateidObj={this.state.relateidObj}
                    siderComponent={this.siderRef && this.siderRef.current} //将MySider的实例传给content
                    // [NCC-45253]大佬们要求把这个新作的功能去掉
                    origQueryWorkbenchData={this.state.origQueryWorkbenchData}
                    disableDeduplicate={this.state.disableDeduplicate}
                    duplicateInEditing={this.state.duplicateInEditing}
                    onCheckDeduplication={this.onCheckDeduplication}
                    onEnterEditable={this.onEnterEditable}
                    getEmptyGroupInfo={this.getEmptyGroupInfo}
                    gridContainerPadding={[editable ? 6 : 4, editable ? 10 : 2]}
                />
                {/* 子组件传方法 */}
                <CustomDragLayer />
                {/* 工作台管理节点进桌面显示注意事项 */}
                {/* {this.renderHelpTip()} */}
                {this.props.editable && (
                    <HelpToolTip
                        getPopupContainer={() => this.desktopSettingRef}
                        json={this.props.json}
                        isMount={this.props.siderCollapsed}
                    >
                        <div className="collapsed-line" onClick={() => {
                            this.props.setLeftHelpTipVisible(false); // 点击自动关闭提示框，下次打开编辑再次打开提示框
                            this.props.setSiderCollapsed(false);
                        }}>
                            <div className="collapse-btn collapsed">
                                <i class="iconfont icon-ncc-sq" fieldid="expand" />
                            </div>
                        </div>
                    </HelpToolTip>
                )}
            </div>,
            !isDesign ? btnsArea : null // 操作按钮区
        ];
    }
}
export default connect(
    (state) => ({
        json: state.gridLayoutData.json,
        editable: state.gridLayoutData.editable,
        siderCollapsed: state.gridLayoutData.siderCollapsed,
        workbenchData: state.appData.workbenchData
    }),
    {
        updateGroupList,
        clearData,
        initGroups,
        setJson,
        toggleEditStatus,
        setAppGroupData,
        setSiderCollapsed,
        setWorkbenchId,
        setLinkageData,
        setLeftHelpTipVisible,
        setDefaultAppGroupData,
        updateEditSiderStatus,
        setWorkbenchConfig
    }
)(withDragDropContext(HomePage));
